import { render, staticRenderFns } from "./FileDeleteButton.vue?vue&type=template&id=08d7fe7c&scoped=true&lang=html"
import script from "./FileDeleteButton.vue?vue&type=script&lang=js"
export * from "./FileDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d7fe7c",
  null
  
)

export default component.exports